import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputField = styled.input<{ type: string; placeholder: string; theme: Theme; }>`
  font-size: 18px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.inputBorder};
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
  ::placeholder {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${({theme}) => theme.inputPlaceholder};
  }
`;

export const InputLabel = styled.text`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  color: #00234D;
  margin-left: 10px;
  margin-top: 20px;
`;

export const HelperText = styled.text`
  position: relative;
  top: -47px;
  left: 78vw;
  height: 0px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${({theme}) => theme.inputPlaceholder};
`;

